<div class="container">
  <h3 class="mt-1">{{ 'Last ' + historyExecutions.length + ' executions' }}</h3>
  <table mat-table [dataSource]="dataSource" matSort matSortDisableClear class="w-100">
    <ng-container matColumnDef="initialExecutionTime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Initial Execution</th>
      <td mat-cell *matCellDef="let element">{{ element.initialExecutionTime | date:'MM/dd/yyyy hh:mm a' }} </td>
    </ng-container>
    <ng-container matColumnDef="finalExecutionTime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Final Execution</th>
      <td mat-cell *matCellDef="let element">{{ element.finalExecutionTime | date:'MM/dd/yyyy hh:mm a' }} </td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let element">{{ element.type }}</td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let element">
        <ns-status [status]="element.status ? element.status.toLowerCase() : 'inactive'"></ns-status>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns;"></tr>
  </table>
</div>
